import * as types from "../actions/types";

export const initState = {
  genderList: [],
  titleList: [],
  chargingSites: [],
  vehicleBrands: [],
  vehicleModels: [],
  vehicleChargerTypes: [],
  addressTypes: [],
  cityList: [],
  countryList: [],
  stateList: [],
  addressTypeList: [],
  driverNotifications: [],
  stationManagerNumberList: [],
  bookings: [],
  bookingAddress: [],
  bookingAddressStatus: true,
  bookingDetails: [],
  chargingSiteBundles: [],
  parkingSlots: [],
  bookingCreationStatus: false,
  stationNameList: [],
  planSelectionNameList: [],
  planStationBundleList: [],
  parkingSlotsList: [],
  DriverBundleSubscriptionCreationStatus: false,
  bundleDayReferenceList: [],
  dayReferenceChargingSiteBundleList: [],
  dayShareParkingSlotsList: [],
  driverBundleSubscriptions: [],
  apiEndPointFailed: { title: "", isApiEndPointFailed: false, bodyMessage: "" },
  paymentDetails: [],
  chargeDetails: [],
  driverChargingSites: [],
  allChargingSites: [],
  evChargingSiteId: localStorage.getItem("ev_charging_site_id"),
  showToast: { text: "", display: false },
  appOnlineOfflineModeDisplay: true,
  isCharging: false
};

const driverReducer = (state = initState, action) => {
  switch (action.type) {
    case types.GET_GENDER:
      return {
        ...state,
        genderList: action.payload,
      };
    case types.GET_ADDRESS_TYPE:
      return {
        ...state,
        addressTypes: action.payload,
      };
    case types.GET_TITLE:
      return {
        ...state,
        titleList: action.payload,
      };
    case types.GET_CHARGING_SITES:
      return {
        ...state,
        chargingSites: action.payload,
      };
    case types.GET_VEHICLE_BRANDS:
      return {
        ...state,
        vehicleBrands: action.payload,
      };
    case types.GET_VEHICLE_MODELS:
      return {
        ...state,
        vehicleModels: action.payload,
      };
    case types.GET_VEHICLE_CHARGER_TYPES:
      return {
        ...state,
        vehicleChargerTypes: action.payload,
      };
    case types.GET_CITY:
      return {
        ...state,
        cityList: action.payload,
      };
    case types.GET_COUNTRY:
      return {
        ...state,
        countryList: action.payload,
      };
    case types.GET_STATE:
      return {
        ...state,
        stateList: action.payload,
      };
    case types.GET_ADDRESS_TYPE:
      return {
        ...state,
        addressTypeList: action.payload,
      };
    case types.GET_STATION_MANAGER_NUMBER:
      return {
        ...state,
        stationManagerNumberList: action.payload,
      };
    case types.GET_READ_NOTIFICATION:
      return {
        ...state,
        driverNotifications: action.payload,
      };
    case types.GET_BOOKINGS:
      return {
        ...state,
        bookings: action.payload,
        bookingCreationStatus: false,
      };
    case types.GET_BOOKING_ADDRESS:
      return {
        ...state,
        bookingAddress: action.payload,
        bookingAddressStatus: action.payload && action.payload.length > 0,
      };
    case types.GET_CHARGE_BOX_CHARGING:
      return {
        ...state,
        isCharging: action.payload
      };
    case types.GET_BOOKING_DETAILS:
      return {
        ...state,
        bookingDetails: action.payload,
      };
    case types.GET_CHARGING_SITES_BUNDLES:
      return {
        ...state,
        chargingSiteBundles: action.payload,
      };
    case types.GET_STATION_NAME:
      return {
        ...state,
        stationNameList: [{ ...action.payload }],
        DriverBundleSubscriptionCreationStatus: false,
      };
    case types.GET_PLAN_SELECTION_NAME:
      return {
        ...state,
        planSelectionNameList: action.payload,
      };
    case types.GET_PLAN_STATION_BUNDLE:
      return {
        ...state,
        planStationBundleList: action.payload,
      };
    case types.GET_PARKING_SLOTS:
      return {
        ...state,
        // parkingSlots: action.payload,
        parkingSlotsList: action.payload,
      };
    case types.BOOKING_CREATED_SUCCESSFULLY:
      return {
        ...state,
        bookingCreationStatus: action.payload,
        parkingSlotsList: action.payload,
      };
    case types.CLEAR_PARKING_SLOTS:
      return {
        ...state,
        parkingSlotsList: [],
      };
    case types.DRIVER_BUNDLE_SUBSCRIPTION_CREATED:
      return {
        ...state,
        DriverBundleSubscriptionCreationStatus: true,
      };
    case types.GET_BUNDLE_DAY_REFERENCE:
      let sorting = [...action.payload];
      sorting.sort((a, b) => a.day_sequence - b.day_sequence);
      return {
        ...state,
        bundleDayReferenceList: sorting,
      };
    case types.GET_DAY_REFERENCE_CHARGING_SITE_BUNDLE:
      return {
        ...state,
        dayReferenceChargingSiteBundleList: action.payload,
      };
    case types.GET_DAYSHARE_PARKING_SLOTS:
      return {
        ...state,
        parkingSlotsList: action.payload,
      };
    case types.GET_DRIVER_BUNDLE_SUBSCRIPTIONS:
      return {
        ...state,
        driverBundleSubscriptions: action.payload,
      };
    case types.API_ENDPOINT_FAILED:
      return {
        ...state,

        apiEndPointFailed: {
          title: action.payload.isApiEndPointFailed ? action.payload.title : "",
          bodyMessage: action.payload.bodyMessage,
          isApiEndPointFailed: action.payload.isApiEndPointFailed,
        },
      };
    case types.GET_PAYMENT_DETAIL:
      return {
        ...state,
        paymentDetails: action.payload,
      };
    case types.GET_CHARGE_DETAIL:
      return {
        ...state,
        chargeDetails: action.payload,
      };
    case types.GET_DRIVER_CHARGING_SITES:
      return {
        ...state,
        driverChargingSites: action.payload,
      };
    case types.GET_ALL_CHARGING_SITES:
      return {
        ...state,
        allChargingSites: action.payload,
      };
    case types.UPDATE_EV_CHARGING_SITE_ID:
      return {
        ...state,
        evChargingSiteId: action.payload,
      };
    case types.SHOW_TOAST:
      return {
        ...state,
        showToast: action.payload,
      };
    case types.APP_ONLINE_OFFLINE_MODE:
      return {
        ...state,
        appOnlineOfflineModeDisplay: action.payload,
      };
    default:
      return state;
  }
};

export default driverReducer;
